import { Divider, Box } from '@wix/design-system';
import React, { useContext, useState } from 'react';
import { RicosContext, ModalContext, EditorContext } from 'ricos-context';
import { unreachable } from 'wix-rich-content-editor-common';
import { SidePanelLayout, FooterActions } from 'wix-rich-content-ui-components';
import { T as TabNavigation, c as classes } from '../../tab-navigation-f3eb4402.js';
import { SETTINGS_TAB, POLL_SETTINGS_MODAL_ID } from '../../consts.js';
import { POLLS_SETTINGS_MODAL } from '../../dataHooks.js';
import { POLL_TYPE } from '../../types.js';
import { DesignSettingsSection } from './design-settings-section.js';
import { LayoutSettingsSection } from './layout-settings-section.js';
import { PollSettingsSection } from './poll-settings-section.js';
import '../../style-inject.es-e7b07dd7.js';
import 'ricos-schema';
import 'ricos-schema/next';
import '../../defaults.js';
import '../../helpers.js';
import 'wix-rich-content-common/libs/imageUtils';
import './section.js';
import '../../assets/icons/ColorIcon.js';
import '../../assets/icons/GradientIcon.js';
import '../../assets/icons/ImageIcon.js';
import 'wix-rich-content-plugin-commons';
import '../../assets/icons/LayoutListIcon.js';
import '../../assets/icons/LayoutGridIcon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SettingsModal = ({
  nodeId,
  activeTab: initialTab,
  config
}) => {
  const { t, isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalContext);
  const { getEditorCommands } = useContext(EditorContext);
  const [activeTab, setActiveTab] = useState(initialTab != null ? initialTab : "layout");
  const [initialData] = useState(() => getEditorCommands().getBlockComponentData(nodeId));
  const componentData = getEditorCommands().getBlockComponentData(nodeId);
  const updateRicosDocument = (data) => {
    queueMicrotask(() => {
      getEditorCommands().setBlock(nodeId, POLL_TYPE, __spreadProps(__spreadValues(__spreadValues({}, componentData), data), { id: nodeId }));
    });
  };
  const closeModal = () => modalService.closeModal(POLL_SETTINGS_MODAL_ID);
  const handleOnCancel = () => {
    updateRicosDocument(initialData);
    closeModal();
  };
  if (!componentData) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    SidePanelLayout,
    {
      dataHook: POLLS_SETTINGS_MODAL,
      onCloseButtonClick: closeModal,
      header: {
        showDivider: false,
        title: t("Poll_PollSettings_Common_Header"),
        children: /* @__PURE__ */ React.createElement(React.Fragment, null, !isMobile && /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(TabNavigation, { activeTab, onTabChange: setActiveTab }))
      },
      content: {
        noPadding: true,
        children: /* @__PURE__ */ React.createElement(Box, { marginLeft: "SP4", marginRight: "SP4", direction: "vertical", className: classes.content }, (() => {
          switch (activeTab) {
            case SETTINGS_TAB.layout:
              return /* @__PURE__ */ React.createElement(
                LayoutSettingsSection,
                {
                  componentData,
                  updateRicosDocument
                }
              );
            case SETTINGS_TAB.design:
              return /* @__PURE__ */ React.createElement(
                DesignSettingsSection,
                {
                  componentData,
                  updateRicosDocument
                }
              );
            case SETTINGS_TAB.settings:
              return /* @__PURE__ */ React.createElement(
                PollSettingsSection,
                {
                  componentData,
                  config,
                  updateRicosDocument
                }
              );
            default:
              unreachable(activeTab);
              return null;
          }
        })())
      },
      footer: { children: /* @__PURE__ */ React.createElement(FooterActions, { onSave: closeModal, onCancel: handleOnCancel }) }
    }
  );
};

export { SettingsModal };
//# sourceMappingURL=settings-modal.js.map
